import React from 'react';

// Pages
import Home from '../pages/Home';
import About from '../pages/About';
import Services from '../pages/Services';
import ServiceDetail from '../pages/ServiceDetail';
import BookingPage from '../pages/BookingPage';
import Contact from '../pages/Contact';
import PageDetail from '../pages/PageDetail';
import Sitemap from '../pages/Sitemap';
import NotFound from '../pages/NotFound';

export const appRoutes = [
  {
    key: 'home',
    path: '/',
    element: <Home />,
    label: 'Home',
    includeInSitemap: true,
  },
  {
    key: 'about',
    path: '/about',
    element: <About />,
    label: 'About Us',
    includeInSitemap: true,
  },
  {
    key: 'services',
    path: '/services',
    element: <Services />,
    label: 'Services',
    includeInSitemap: true,
  },
  {
    key: 'service-detail',
    path: '/services/:slug',
    element: <ServiceDetail />,
    includeInSitemap: false,
  },
  {
    key: 'page-detail',
    path: '/page/:slug',
    element: <PageDetail />,
    includeInSitemap: false,
  },
  {
    key: 'book',
    path: '/book',
    element: <BookingPage />,
    label: 'Book Appointment',
    includeInSitemap: true,
  },
  {
    key: 'contact',
    path: '/contact',
    element: <Contact />,
    label: 'Contact',
    includeInSitemap: true,
  },
  {
    key: 'sitemap',
    path: '/sitemap',
    element: <Sitemap />,
    label: 'Sitemap Overview',
    includeInSitemap: true,
  },
  {
    key: 'not-found',
    path: '*',
    element: <NotFound />,
    includeInSitemap: false,
  },
];
